import React from "react";
import MobileHeader from "../components/MobileHeader";
import Sidebar from "../components/Sidebar";
import OffcanvasSidebar from "../components/OffcanvasSidebar";
import Header from "./Header";
import { useMatch } from "react-router-dom";

const MainLayout = ({ children }) => {
  let isMatch = useMatch("/audit-details/:id");
  return (
    <>
      <MobileHeader />
      <OffcanvasSidebar />
      <Sidebar />
      <main className="content-area">
        {isMatch ? null : <Header />}
        {children}
      </main>
    </>
  );
};

export default MainLayout;
